export enum ActivityType {
  loginSuccess = "loginSuccess",
  loginFailed = "loginFailed",
  logout = "logout",
  rosterGame = "rosterGame",
  changePassword = "changePassword",
  updateShift = "updateShift",

  resetPasswordRequestAuthed = "requestChangeRequest",
  resetPasswordRequestAuthedSuccess = "requestPasswordRequestSuccess",
  resetPasswordRequestAnon = "resetPasswordRequestAnon",
  resetPasswordRequestAnonSuccess = "resetPasswordRequestAnonSuccess",

  confirmShift = "confirmShift",

  deleteGame = "deleteGame",
  createCalendar = "createCalendar",

  accessedSecureDetails = "accessedSecureDetails",
  updatedSecureDetails = "updatedSecureDetails",

  updateAppointmentStatus = "updateAppointmentStatus",

  createPerson = "createPerson",
  updatePerson = "updatePerson",

  gameMove = "gameMove",
}

export namespace ActivityType {
  export function toDisplayString(type: ActivityType) {
    switch (type) {
      case ActivityType.changePassword:
        return "Change password";
      case ActivityType.loginSuccess:
        return "Successful login";
      case ActivityType.loginFailed:
        return "Unsuccessful login attempt";
      case ActivityType.logout:
        return "Logged out";
      case ActivityType.rosterGame:
        return "Rostered game";
      case ActivityType.updateShift:
        return "Updated a shift";
      default:
        return type;
    }
  }
}
